import { Flex, useBreakpointValue } from "@chakra-ui/react";
import { FootDesktop } from "./footerDesktop";
import { FootMobile } from "./footerMobile";

export function Footer() {
  const isWideVersion = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });
  return <Flex>{isWideVersion ? <FootDesktop /> : <FootMobile />}</Flex>;
}
